var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHandCrossed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93945 8.1107V16.3021C4.93945 20.9268 7.48135 23 11.0288 23C13.2821 23 14.9581 22.2495 16.2989 20.8236C16.5195 20.5891 16.7226 20.34 16.9098 20.0811L7.81655 10.9878V12.9437C7.45342 13.0938 7.10891 13.272 6.80165 13.469V9.9729L4.93945 8.1107Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81655 8.86648L9.67875 10.7287V4.66041C9.67875 4.16323 9.36217 3.71295 8.74765 3.71295C8.13312 3.71295 7.81655 4.16323 7.81655 4.66041V8.86648Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6936 11.7436L17.7066 18.7565C18.3567 17.4632 18.7216 16.1272 18.9662 15.2316C19.0272 15.0082 19.0808 14.8122 19.1294 14.651C19.219 14.3599 19.3309 14.0454 19.4428 13.7311C19.6914 13.0327 19.9395 12.3359 19.9395 11.9024C19.9395 11.4991 19.4087 11.1426 19.0549 11.1426C18.2542 11.1426 17.9469 11.5084 17.4814 12.5216C17.3349 12.8352 17.1796 13.225 17.0208 13.6235C16.6145 14.6436 16.1855 15.7205 15.824 15.7205C15.5354 15.7205 15.4329 15.1951 15.4329 14.2195V5.16698C15.4329 4.66979 15.135 4.21951 14.5018 4.21951C13.878 4.21951 13.5707 4.66979 13.5707 5.16698V12.5779C13.2728 12.4934 12.9283 12.4184 12.5558 12.3715V3.93809C12.5558 3.4409 12.2486 3 11.6247 3C11.0009 3 10.6936 3.4409 10.6936 3.93809V11.7436Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80165 7.85158L5.61202 6.66194C5.69626 6.64143 5.78861 6.63039 5.88917 6.63039C6.51301 6.63039 6.80165 7.08068 6.80165 7.57786V7.85158Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06066 1L23.1862 22.1256L22.1256 23.1862L1 2.06066L2.06066 1Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHandCrossed);
export default __webpack_public_path__ + "static/media/icon-hand-crossed.abb170626e4b005fb5ec1c6e829b0b3a.svg";
export { ForwardRef as ReactComponent };